import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { Utils } from "../../common/utils";
import { ContextService } from "../../services/context.service";
import { MatchService } from "../../services/match.service";

export interface ISelectedPlayer {
  id: number;
  name: string;
}
@Component({
  selector: "app-players-list",
  templateUrl: "./players-list.component.html",
  styleUrls: ["./players-list.component.scss"],
})
export class PlayersListComponent implements OnInit, OnDestroy {
  private _selected: ISelectedPlayer = null;
  private _live = false;
  private _stats: any = {};
  private _team: any = {};
  private _players: any[] = [];

  private currentPageLineUp = 0;
  private totalPageLineUp = 1;
  public maxVisiblePlayer = 7;
  public fadeClass = false;

  get players() {
    return this._players;
  }
  set players(players) {
    const isSameTeam =
      this.players.length === players.length &&
      this.players.every((currentPlayer) => {
        return players.some(
          (_currentPlayer) => currentPlayer.id === _currentPlayer.id
        );
      });

    if (!isSameTeam) {
      this._players = players;
    } else {
      this._players.forEach((player) => {
        const playerWithNewStats = players.find((pl) => player.id === pl.id);
        Object.keys(playerWithNewStats).forEach((key) => {
          player[key] = playerWithNewStats[key];
        });
      });
    }
  }

  @Input() typeTeam = "";
  @Input() disabled = false;
  @Input() get team(): any {
    return this._team;
  }
  set team(team: any) {
    this._team = team;
    this.players = team.players;
  }
  @Input() get selected(): ISelectedPlayer {
    return this._selected;
  }
  set selected(selected: ISelectedPlayer) {
    this._selected = selected;
    this.playerSelected.emit(this._selected);
  }
  @Input() get live(): boolean {
    return this._live;
  }
  set live(live: boolean) {
    this._live = live;
  }
  @Input() get stats(): any[] {
    return this._stats;
  }
  set stats(stats: any[]) {
    this._stats = this.parseStats(stats);
  }
  @Output() playerSelected = new EventEmitter();

  utils = Utils;

  constructor() {}

  ngOnInit() {
    this.resizePlayerList();
    window.addEventListener("resize", this.resizePlayerList.bind(this));
  }

  ngOnDestroy() {
    window.removeEventListener("resize", this.resizePlayerList.bind(this));
  }

  onImageError(event: any) {
    // A bit of vanilla JS
    event.currentTarget.parentElement.classList.add("placeholder");
  }

  selectPlayer(player, $event) {
    if (!this.disabled) {
      if (this.selected !== null && this.selected.id === player.id) {
        this.selected = null;
      } else {
        this.selected = player;
      }
    }
  }

  parseStats(data) {
    const playersStats = {};
    data.forEach((elem) => {
      playersStats[elem.player_id] = elem;
    });
    return playersStats;
  }

  resizePlayerList() {
    this.setMaxVisiblePlayers();
  }

  setMaxVisiblePlayers() {
    const widthScreen = window.innerWidth;

    if (widthScreen > 1280) {
      this.maxVisiblePlayer = 11;
    } else if (widthScreen > 1024) {
      this.maxVisiblePlayer = 9;
    } else {
      this.maxVisiblePlayer = 7;
    }
  }

  changeNavPage(move) {
    // Fade effect
    this.fadeClass = true;
    setTimeout(() => {
      this.fadeClass = false;
      if (move > 0) {
        // avanza
        if (
          this.currentPageLineUp <
          this.players.length / this.maxVisiblePlayer
        ) {
          this.currentPageLineUp++;
        }
      } else {
        // retrocede
        if (this.currentPageLineUp > 0) {
          this.currentPageLineUp--;
        }
      }
    }, 500);
  }

  get currentVisibleTeam(): any {
    let initPos =
      this.currentPageLineUp * this.maxVisiblePlayer > this.players.length
        ? this.players.length - this.maxVisiblePlayer
        : this.currentPageLineUp * this.maxVisiblePlayer;
    const lastPos =
      this.currentPageLineUp * this.maxVisiblePlayer + this.maxVisiblePlayer >
      this.players.length
        ? this.players.length
        : initPos + this.maxVisiblePlayer;

    if (lastPos === this.players.length) {
      initPos = this.players.length - this.maxVisiblePlayer;
    }

    this.totalPageLineUp = Math.trunc(
      this.players.length / this.maxVisiblePlayer
    );

    return this.players.slice(initPos, lastPos);
  }
}
